import type { MetricActivationReadiness } from '../projections.ts';

/** Human-facing copy for a proposed KPI whose owner-defined activation precondition is blocked. */
export function blockedActivationReason(readiness: MetricActivationReadiness | null): string {
  if (readiness === null) return 'Activation readiness is unavailable; activation remains blocked.';
  if (readiness.ready) return '';
  switch (readiness.reason) {
    case 'definition_needs_clarification':
      return 'Definition clarification is required before activation.';
    case 'collector_missing':
      return 'Collector setup is required before activation.';
    case 'collector_not_validated':
      return 'The Collector must pass a dry validation trial before activation.';
    case 'not_proposed':
      return 'This KPI is not in an activatable state.';
    case 'proposal_rejected':
      return 'This KPI proposal revision was rejected.';
    case 'changes_requested':
      return 'Changes were requested before this KPI can be activated.';
  }
}
